import React from "react";
import { shallowEqual, useSelector } from "react-redux";
import { isEmpty } from "../../../utils/lodashExtend";
import { transform } from "../../../utils/validator";



const TaxAccountantInfo = () => {
  const {
    myCompany
  } = useSelector(
    (store) => ({
      myCompany: store.Data.myCompany,
    }),
    shallowEqual
  );

  return (
    <div className="home-tax-wrap">
      {!isEmpty(myCompany) && <>
        <span className="font-size-18">{myCompany.name}</span> {transform(myCompany.comNum, 'comNum')}
      </>}
    </div>
  );
};

export default TaxAccountantInfo;